module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEmSURBVHgB7dZBTsJAFAbgN1N0zVFGI3u9i2CMG3sSZaGJ1LvoHhJ7lK5V3mOGFZQmnSZ9HQj/l0xCJg3tD528nwgAAACauenChUWKLCm5nn28ZEZ+wrrxn0mJIQUT/6uzf/DdvfXIXJXvs5J6pvIP/IkZ1/dGv+sxKVB7hYaCAKkhQGoIkNrJB+g0ibe9pmFI1VnLzn/xXn0QopzZtk9iI1VZxE/s6ACh2/iLn2kA/j6vq8VDHnltu6Zuoy22O53HIV6Gd1JkTkMxMo9trp0O8WT65kRs6yFmaw8PMVNuiVsfyhiulsVT/4e4C3df3GaWv/ZuxHy3+nz8pp5hkKWGAKkhQGoIkJpKgAtfiet7/5dZRQpUAhx0pw7d5qiE7hQWAQAAQLMNRzxfhe5kQ0AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-follow-blue.png
// module id = N/oq
// module chunks = 36